
import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);
const TOKEN_KEY = "kataco_access_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem(TOKEN_KEY);

    if (!token) {
      setUser(false);
      return;
    }

    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        sessionStorage.removeItem(TOKEN_KEY);
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });

    if (!data.access_token) {
      throw new Error("Login response did not include an access token.");
    }

    sessionStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // Continue logging out locally if the server request fails.
    }

    sessionStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
